import { useCallback, useEffect, useRef, useState } from "react"
import { useSearch } from "./useSearch";
import { getInvites } from "../../services/communityService";
import { ApiArrayResponseModel } from "./models/ApiResponseModel";
import { InviteModel } from "./models/InviteModel";
import { CommunityTagModel } from "../../pages/community/models/CommunityTagModel";

export const useInvites = (search: string) => {
    const isMountedRef = useRef(true);
    const [invites, setInvites] = useState<CommunityTagModel[]>([]);
    const searchValue = useSearch(search, 250);

    useEffect(() => {
        return () => {
            isMountedRef.current = false;
        }
    }, []);

    const load = useCallback(async () => {
        try {
            if(!searchValue) {
                setInvites([]);
                return;
            }
            
            const _data: ApiArrayResponseModel<InviteModel> = await getInvites(searchValue);   
            if(!isMountedRef.current)
                return;
            const _options = _data.results.map(r => ({
                value: r,
                label: r.fullName,
                imageUrl: r.avatar
            })) as CommunityTagModel[];
            setInvites(_options);
        }
        catch { }
    }, [searchValue]);

    useEffect(() => {
        load();
    }, [load]);

    return { invites }
}